/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { DocumentListComponentDisplay } from "cms/components/components/document-list/display/index";
import { DocumentListComponentEditor } from "cms/components/components/document-list/edit/index";
import { getComponentZoneLayout } from "cms/components/components/component";

const DocumentListComponent = (props) => {
    
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <DocumentListComponentDisplay />,
        editComponent: <DocumentListComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

DocumentListComponent.displayName = "DocumentListComponent";
export { DocumentListComponent };
